const SENSITIVE_AUTH_KEYS = new Set([
  'access_token', 'refresh_token', 'code', 'token', 'token_hash', 'provider_token', 'provider_refresh_token',
]);

export function hasSensitiveAuthParameters(locationLike = window.location) {
  const query = new URLSearchParams(locationLike.search || '');
  const hash = new URLSearchParams(String(locationLike.hash || '').replace(/^#/, ''));
  return [...SENSITIVE_AUTH_KEYS].some((key) => query.has(key) || hash.has(key));
}

export function cleanAuthUrl(locationLike = window.location, historyLike = window.history) {
  const url = new URL(locationLike.href);
  for (const key of SENSITIVE_AUTH_KEYS) url.searchParams.delete(key);
  const hash = new URLSearchParams(url.hash.replace(/^#/, ''));
  for (const key of SENSITIVE_AUTH_KEYS) hash.delete(key);
  url.hash = hash.toString() ? `#${hash.toString()}` : '';
  const clean = `${url.pathname}${url.search}${url.hash}`;
  historyLike.replaceState(historyLike.state, document.title, clean);
  return clean;
}

export function clearLegacyTokenStorage(storage = window.localStorage) {
  storage.removeItem('supabase_access_token');
  storage.removeItem('supabase_refresh_token');
}
